var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7466 19.9997C8.3916 19.9997 7.0706 19.9847 5.7636 19.9577C4.0916 19.9247 2.9346 18.8407 2.7456 17.1287C2.4306 14.2887 1.8916 7.59466 1.8866 7.52766C1.8526 7.11466 2.1606 6.75266 2.5736 6.71966C2.9806 6.70866 3.3486 6.99466 3.3816 7.40666C3.3866 7.47466 3.9246 14.1457 4.2366 16.9637C4.3436 17.9367 4.8686 18.4387 5.7946 18.4577C8.2946 18.5107 10.8456 18.5137 13.5956 18.4637C14.5796 18.4447 15.1116 17.9527 15.2216 16.9567C15.5316 14.1627 16.0716 7.47466 16.0776 7.40666C16.1106 6.99466 16.4756 6.70666 16.8846 6.71966C17.2976 6.75366 17.6056 7.11466 17.5726 7.52766C17.5666 7.59566 17.0246 14.3067 16.7126 17.1217C16.5186 18.8687 15.3646 19.9317 13.6226 19.9637C12.2896 19.9867 11.0036 19.9997 9.7466 19.9997Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.208 4.98877H1.25C0.836 4.98877 0.5 4.65277 0.5 4.23877C0.5 3.82477 0.836 3.48877 1.25 3.48877H18.208C18.622 3.48877 18.958 3.82477 18.958 4.23877C18.958 4.65277 18.622 4.98877 18.208 4.98877Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9403 4.989C13.8023 4.989 12.8143 4.178 12.5903 3.062L12.3473 1.846C12.2963 1.661 12.0853 1.5 11.8453 1.5H7.61233C7.37233 1.5 7.16133 1.661 7.10033 1.892L6.86733 3.062C6.64433 4.178 5.65533 4.989 4.51733 4.989C4.10333 4.989 3.76733 4.653 3.76733 4.239C3.76733 3.825 4.10333 3.489 4.51733 3.489C4.94333 3.489 5.31333 3.185 5.39733 2.767L5.64033 1.551C5.88733 0.619 6.69433 0 7.61233 0H11.8453C12.7633 0 13.5703 0.619 13.8073 1.506L14.0613 2.767C14.1443 3.185 14.5143 3.489 14.9403 3.489C15.3543 3.489 15.6903 3.825 15.6903 4.239C15.6903 4.653 15.3543 4.989 14.9403 4.989Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cb5042adf9b1a6d7efdf80ff62d65f8c.svg";
export { ForwardRef as ReactComponent };